/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { radioStateModelSchema } from "../radioStateModelSchema.ts";
import { z } from "zod";

/**
 * @description Статус радио
 */
export const getApiPurewaveSettingRadio200Schema = z.lazy(() => radioStateModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiPurewaveSettingRadio400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiPurewaveSettingRadio401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiPurewaveSettingRadio403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiPurewaveSettingRadio500Schema = z.lazy(() => badResponseModelSchema)

export const getApiPurewaveSettingRadioQueryResponseSchema = z.lazy(() => getApiPurewaveSettingRadio200Schema)